import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { routing } from './app.routing';
import { TourApiService } from './services/tour-api.service';
import { SurveyApiService } from './services/survey-api.service';
import { ModalService } from './services/modal.service';
import { TourService } from './services/tour.service';
import { TrackingService } from './services/tracking.service';
import { WishlistService } from './services/wishlist.service';

import { HomeComponent } from './components/home.component';
import { VgCoreModule } from 'videogular2/core';
import { VgControlsModule } from 'videogular2/controls';
import { VgOverlayPlayModule } from 'videogular2/overlay-play';
import { VgBufferingModule } from 'videogular2/buffering';
import { VideoPlayerComponent } from './components/video-player.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  MatButtonModule, MatDialog, MatDialogModule, MatMenuModule, MatSelectModule,
  MatTooltipModule
} from '@angular/material';
import { OptionDetailComponent } from './components/option-detail.component';
import { TourComponent } from './components/tour.component';
import { VideoPlayerDialogComponent } from './components/video-player-dialog.component';
import { NavToolbarComponent } from './shared/nav-toolbar.component';
import { AboutComponent } from './components/about.component';
import { CommunityComponent } from './components/community.component';
import { ContactsComponent } from './components/contacts.component';
import { FeedbackComponent } from './components/feedback.component';
import { ImageListComponent } from './shared/image-list.component';
import { RatingBarComponent } from './shared/rating-bar.component';
import { StarsComponent } from './shared/stars.component';
import { SafePipe } from './shared/safe-pipe';
import { DateFormatPipe } from './shared/date-pipe';
import { FeaturesComponent } from './components/features.component';
import { FeaturesSidebarComponent } from './components/features-sidebar.component';
import { TourGuard} from './services/tour.guard';
import { ImageDialogComponent } from './components/image-dialog.component';
import { BuilderListComponent } from './components/builder-list.component';
import { SocialComponent } from './components/social.component';
import { TruncatePipe } from './shared/truncate-pipe';
import { WishlistComponent } from './components/wishlist.component';
import { SharedWishlistComponent } from './components/shared-wishlist.component';
import {MicroApiService} from './services/micro-api.service';
import {FeedbackDialogComponent, FooterComponent} from './shared/footer.component';
import {TagComponent} from './components/tag.component';
import {LazyLoadImageModule} from './modules/lazy-load/lazyload-image.module';
import { FrequencyBarsComponent } from './shared/frequency-bars.component';
import {HttpClientModule} from '@angular/common/http';
import {OptionDetailService} from './services/option-detail.service';

@NgModule({
  declarations: [
    AppComponent,
    AboutComponent,
    BuilderListComponent,
    CommunityComponent,
    ContactsComponent,
    DateFormatPipe,
    FeaturesComponent,
    FeaturesSidebarComponent,
    FeedbackComponent,
    FrequencyBarsComponent,
    HomeComponent,
    ImageListComponent,
    ImageDialogComponent,
    NavToolbarComponent,
    OptionDetailComponent,
    RatingBarComponent,
    SocialComponent,
    StarsComponent,
    SafePipe,
    TourComponent,
    TruncatePipe,
    VideoPlayerComponent,
    VideoPlayerDialogComponent,
    WishlistComponent,
    ImageDialogComponent,
    BuilderListComponent,
    SocialComponent,
    SharedWishlistComponent,
    FooterComponent,
    TagComponent,
    FeedbackDialogComponent,
    FrequencyBarsComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    MatButtonModule,
    MatDialogModule,
    MatMenuModule,
    MatTooltipModule,
    MatSelectModule,
    routing,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    LazyLoadImageModule
  ],
  entryComponents: [
    ImageDialogComponent,
    OptionDetailComponent,
    VideoPlayerDialogComponent,
    FeedbackDialogComponent
  ],
  providers: [TourApiService, SurveyApiService, MatDialog, ModalService, MicroApiService,
              TourGuard, TourService, TrackingService, WishlistService, OptionDetailService],
  bootstrap: [AppComponent]
})
export class AppModule { }

// ng serve -host xxx.xxx.xxx.xxx -port 8080



// WEBPACK FOOTER //
// ./src/app/app.module.ts